import React, { memo } from 'react';
import { Avatar } from 'antd';

/** Fixed palette of muted tones — the same name always gets the same color. */
const PALETTE = [
  '#7c93ad',
  '#8d7cad',
  '#ad7c93',
  '#7cad8d',
  '#ad9b7c',
  '#7c9fad',
  '#a87c7c',
  '#86ad7c',
];

/** First letters of the first two words, uppercased; '?' when empty. */
const initialsOf = (name?: string | null): string => {
  const words = (name || '').trim().split(/\s+/).filter(Boolean);
  if (words.length === 0) return '?';
  return words
    .slice(0, 2)
    .map((w) => w.charAt(0))
    .join('')
    .toUpperCase();
};

/** Simple deterministic string hash → palette index. */
const hashOf = (s: string): number => {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) % 100003;
  }
  return h;
};

interface IAuthorAvatarProps {
  name?: string | null;
  size?: number;
}

/**
 * Initials avatar for message authors (chat-UI rework): deterministic muted
 * background from the name, white initials. Shared by the group Slack feed and
 * the student communications thread.
 */
export const AuthorAvatar = memo(({ name, size = 24 }: IAuthorAvatarProps) => (
  <Avatar
    size={size}
    style={{
      backgroundColor: PALETTE[hashOf(name || '') % PALETTE.length],
      color: '#fff',
      fontSize: Math.round(size * 0.42),
      fontWeight: 600,
      flexShrink: 0,
    }}
  >
    {initialsOf(name)}
  </Avatar>
));

AuthorAvatar.displayName = 'AuthorAvatar';
